import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=0c23b0ee&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Orders.vue?vue&type=style&index=1&id=0c23b0ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c23b0ee",
  null
  
)

export default component.exports